/**
 * Query keys for Reservation API hooks
 *
 * Centralized query keys enable consistent cache invalidation across all reservation hooks.
 *
 * Usage:
 *   import { reservationQueryKeys } from '~/hooks/apis/reservations/reservationQueryKeys';
 */

export const reservationQueryKeys = {
  all: ['reservations'] as const,
  lists: () => [...reservationQueryKeys.all, 'list'] as const,
  list: (filters?: Record<string, unknown>) => [...reservationQueryKeys.lists(), filters] as const,
  details: () => [...reservationQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...reservationQueryKeys.details(), id] as const,
  vccHistory: (reservationId: string) => [...reservationQueryKeys.detail(reservationId), 'vcc-history'] as const,
};
